import { cn } from "@/lib/utils";
import { View } from "@/components/ui";
import { LuceSparkle } from "@/components/shared/icons";
import { Typography } from "@/components/shared/typography";
import type { FrequencyOption } from "@/components/shared/service-radio-item/types";

export function SectionServiceRadio({
  item,
  selected,
  onSelect,
}: {
  item: FrequencyOption;
  selected: boolean;
  onSelect(): void;
}) {
  return (
    <View className="relative flex h-full flex-1 flex-col">
      <View
        className={cn(
          "flex flex-1 cursor-pointer flex-col gap-3 overflow-hidden rounded-xl border p-3 transition",
          selected
            ? "border-primary-border bg-primary-surface"
            : "border-secondary-border bg-white",
        )}
        onClick={onSelect}
      >
        {item.slogan && (
          <View className="absolute -top-[1px] right-[-1px] rounded-bl-xl rounded-tr-xl bg-success px-3 py-[2px] shadow-sm">
            <Typography variant="caption-md" color="white" numberOfLines={1}>
              {item.slogan}
            </Typography>
          </View>
        )}

        <LuceSparkle className="w-4 text-brand-primary" />

        <View className="flex flex-1 flex-col">
          <Typography variant="label-sm" numberOfLines={2} className="mb-1">
            {item.title}
          </Typography>
          {item.shortDescription && (
            <Typography
              variant="caption-md"
              color="foreground-intermediate"
              className="mb-2"
            >
              {item.shortDescription}
            </Typography>
          )}
          {item.price != null && (
            <Typography
              variant="label-sm"
              className="mt-auto"
              color="brand-primary"
            >
              from ${item.price}/hr
            </Typography>
          )}
        </View>
      </View>
      {selected && (
        <View
          className="absolute left-0 right-0 flex w-full flex-col items-center"
          style={{ bottom: -25, zIndex: 50 }}
        >
          <View className="h-[18px] w-[18px] rotate-45 border-l border-t border-secondary-border bg-background-intermediate" />
        </View>
      )}
    </View>
  );
}
